module.exports = __webpack_public_path__ + "img/category-casino-hover.2705b1b4.png";